import axios from "axios";
import { getApiUrl } from "../utils/constants";
import {
  handleEncodeJson,
  handleDecodeJSON,
} from "../utils/encodeDecodeJson";

const uploadAxios = axios.create();

uploadAxios.interceptors.request.use((config) => {
  const token = axios.defaults.headers.common["authorization"];
  if (token) {
    config.headers["authorization"] = token;
  }
  return config;
});


const buildUrl = (path, token) => {
  const base = getApiUrl();
  return `${base}${path}?token=${token}`;
};


const handleResponse = async (result) => {
  const response = result?.data;

  if (response?.code && response.code !== "OK") {
    const error = new Error(response?.message || "Something went wrong");
    error.code = response.code;
    throw error;
  }

  return handleDecodeJSON({ decodeJSON: response?.data });
};


export const fetchPostExamQuestions = async (token, language) => {
  const url = buildUrl(
    "/api/exam/descriptive-upload/post-exam/questions",
    token
  );
  const params = language ? { language } : {};
  const result = await uploadAxios.get(url, { params });
  return handleResponse(result);
};



export const uploadAnswerFile = async (file, srNo, token) => {
  const url = buildUrl(
    "/api/exam/descriptive-upload/post-exam/upload",
    token
  );
  const encodedPayload = await handleEncodeJson({ encodeJSON: { srNo } });
  const formData = new FormData();
  formData.append("file", file);
  Object.entries(encodedPayload).forEach(([key, val]) => {
    formData.append(key, val);
  });
  const result = await uploadAxios.post(url, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return handleResponse(result);
};

// ---------------------------------------------------------------------------
// deleteAnswerFile
// ---------------------------------------------------------------------------


export const deleteAnswerFile = async (srNo, token) => {
  const url = buildUrl(
    "/api/exam/descriptive-upload/post-exam/delete",
    token
  );
  const encodedBody = await handleEncodeJson({ encodeJSON: { srNo } });
  const result = await uploadAxios.post(url, encodedBody);
  return handleResponse(result);
};

// ---------------------------------------------------------------------------
// submitUploadedAnswers
// ---------------------------------------------------------------------------


export const submitUploadedAnswers = async (token) => {
  const url = buildUrl(
    "/api/exam/descriptive-upload/post-exam/submit",
    token
  );
  const result = await uploadAxios.post(url);
  return handleResponse(result);
};